var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon-dc",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    height: "20px",
    width: "20px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#969696;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512,256C512,114.8,397.2,0,256,0S0,114.8,0,256s114.9,256,256,256S512,397.2,512,256z M39.7,256 c0-119.3,97-216.3,216.3-216.3S472.3,136.7,472.3,256c0,119.3-97,216.3-216.3,216.3S39.7,375.3,39.7,256z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M228.6,369.2l99.1-99.1c7.7-7.7,7.7-20.2,0-28L228.6,143c-7.4-6.4-18.4-6.4-25.8,0c-8.3,7.1-9.3,19.7-2.2,28 l85.1,85.1l-85.1,85.3c-7.7,7.7-7.7,20.2,0,28C208.4,376.9,220.9,376.9,228.6,369.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDc);
export default __webpack_public_path__ + "static/media/dc.5ff4f48a161b4be217e9df94a2df7576.svg";
export { ForwardRef as ReactComponent };